import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Mail } from "lucide-react";
import { cn } from "@/lib/utils";
import expertLars from "@/assets/agent-lars.jpg";
import expertSofia from "@/assets/agent-sofia.jpg";
import expertElena from "@/assets/expert-elena.jpg";
import expertMarco from "@/assets/expert-niels.jpg";
import expertAmond from "@/assets/expret-amond.jpg";
import expertBenjamin from "@/assets/agent-marco.jpg";

type Expert = {
  badge: string;
  name: string;
  role: string;
  image: string;
  paragraphs: string[];
  email: string;
};

const EXPERTS: Expert[] = [
  {
    badge: "Leiter der Rechtsabteilung",
    name: "Lars Koch",
    role: "Spezialist für internationale Rechtsdurchsetzung & Fraud-Recovery",
    image: expertLars,
    email: "lars.koch@veritasberatung.com",
    paragraphs: [
      "Lars Koch leitet den juristischen Bereich von Veritas Beratung und übernimmt die rechtliche Koordination komplexer Fraud-Recovery-Fälle nach Abschluss der investigativen Analyse. Sobald digitale Finanzströme, Täterstrukturen und relevante Vermögenswerte identifiziert wurden, verantwortet er die weiteren rechtlichen Schritte und die strategische Zusammenarbeit mit nationalen und internationalen Behörden.",
      "Mit umfassender Erfahrung im Bereich Wirtschafts- und Finanzkriminalität begleitet er Verfahren im Zusammenhang mit Online-Betrug, Anlagebetrug und grenzüberschreitenden Finanzdelikten. Sein Fokus liegt auf der rechtlichen Aufarbeitung der Fälle, der Kommunikation mit Ermittlungs- und Regulierungsbehörden sowie der Durchsetzung möglicher Ansprüche der Mandanten.",
      "Durch seine strukturierte Vorgehensweise und seine internationale Ausrichtung sorgt Lars Koch dafür, dass komplexe Betrugsfälle professionell, diskret und zielgerichtet weiterverfolgt werden.",
    ],
  },
  {
    badge: "SENIOR RECHTSBERATERIN",
    name: "Elena Weber",
    role: "Expertin für Finanzrecht",
    image: expertElena,
    email: "elena.weber@veritasberatung.com",
    paragraphs: [
      "Elena Weber ist spezialisiert auf Bank- und Kapitalmarktrecht und begleitet komplexe nationale sowie internationale Fälle im Bereich Finanz- und Anlagebetrug. Mit ihrer langjährigen Erfahrung entwickelt sie juristische Strategien zur Absicherung und Durchsetzung von Mandanteninteressen in sensiblen Recovery-Verfahren.",
      "Ihr Schwerpunkt liegt auf der rechtlichen Koordination von Maßnahmen im Zusammenhang mit Kontosperren, regulatorischen Verfahren und internationalen Finanzermittlungen. Durch ihre strukturierte Vorgehensweise und ihre enge Zusammenarbeit mit Behörden und Finanzinstitutionen unterstützt sie Mandanten bei der professionellen Aufarbeitung anspruchsvoller Betrugsfälle.",
    ],
  },
  // {
  //   badge: "Forensik Leitung",
  //   name: "Sophie Neumann",
  //   role: "Expertin für Krypto-Forensik",
  //   image: expertSofia,
  //   email: "sophie.neumann@veritasberatung.com",
  //   paragraphs: [
  //     "Sophie Neumann leitet unsere Blockchain-Analyse und verfolgt Transaktionen über verschiedene Chains und Mixing-Dienste hinweg.",
  //     "Ihre Berichte sind Grundlage für strafrechtliche Verfahren weltweit.",
  //   ],
  // },
  {
    badge: "LEITENDER EXPERTE",
    name: "Armin Ludwig",
    role: "Spezialist für Fraud-Recovery",
    image: expertMarco,
    email: "armin.ludwig@veritasberatung.com",
    paragraphs: [
      "Mit langjähriger Erfahrung in der Bekämpfung internationaler Wirtschafts- und Cyberkriminalität zählt Armin Ludwig zu den führenden Spezialisten im Bereich Fraud-Recovery und digitale Vermögensrückführung.",
      "Er begleitet komplexe Fälle von Anlagebetrug, Online-Scams und grenzüberschreitenden Finanzdelikten und entwickelt strategische Lösungen zur Nachverfolgung digitaler Zahlungsströme und Vermögenswerte.",
      "Durch seine internationale Ausrichtung und die Zusammenarbeit mit Ermittlungs- und Regulierungsbehörden unterstützt er Mandanten bei der professionellen Aufarbeitung und Durchsetzung ihrer Ansprüche – national wie international.",
    ],
  },
  {
    badge: "BLOCKCHAIN & IT EXPERT",
    name: "Bastian Goldmann",
    role: "Spezialist für digitale Forensik & Blockchain-Analyse",
    image: expertAmond,
    email: "bastian.goldmann@veritasberatung.com",
    paragraphs: [
      "Amond Feldberg ist spezialisiert auf digitale Forensik, Blockchain-Analyse und die technische Nachverfolgung komplexer Finanztransaktionen im Bereich Fraud-Recovery. Mit umfassender Expertise in Kryptowährungen, Wallet-Tracking und IT-gestützten Ermittlungsverfahren unterstützt er bei der Analyse internationaler Betrugsstrukturen und der Identifizierung digitaler Vermögenswerte.",
      "Sein Schwerpunkt liegt auf der technischen Auswertung von Blockchain-Daten, der Sicherung digitaler Beweise sowie der Unterstützung strategischer Recovery-Prozesse in Fällen von Online- und Investmentbetrug.",
    ],
  },
  {
    badge: "LEITENDER EXPERTE",
    name: "Rudolf Martin",
    role: "Spezialist für Fraud-Recovery",
    image: expertBenjamin,
    email: "rudolf.martin@veritasberatung.com",
    paragraphs: [
      "Rudolf Martin gehört zu den anerkannten Experten für internationale Fraud-Recovery-Verfahren und die Analyse komplexer Finanzbetrugsstrukturen. Sein Schwerpunkt liegt auf der Identifikation, Sicherung und strategischen Rückführung digitaler Vermögenswerte in Fällen von Online- und Investmentbetrug.",
      "Mit umfassender Erfahrung in internationalen Ermittlungsprozessen unterstützt er Mandanten bei der juristischen und operativen Aufarbeitung sensibler Finanzfälle und koordiniert Maßnahmen mit spezialisierten Partnern und Institutionen weltweit.",
      "Sein analytischer Ansatz und seine Expertise im Bereich digitaler Finanztransaktionen machen ihn zu einem wichtigen Ansprechpartner für anspruchsvolle Betrugs- und Recovery-Fälle.",
    ],
  },
];

export function Experts() {
  const [idx, setIdx] = useState(0);

  const isMobile = () =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;

  const scrollToImageOnMobile = () => {
    if (!isMobile()) return;
    document.getElementById("expert-image-anchor")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const updateExpert = (nextIndex: number) => {
    scrollToImageOnMobile();
    setIdx(nextIndex);
  };

  useEffect(() => {
    const images = EXPERTS.map((expert) => expert.image);
    const preloaders = images.map((src) => {
      const image = new Image();
      image.src = src;
      return image;
    });

    return () => {
      preloaders.forEach((image) => {
        image.src = "";
      });
    };
  }, []);

  const next = () => updateExpert((idx + 1) % EXPERTS.length);
  const prev = () => updateExpert((idx - 1 + EXPERTS.length) % EXPERTS.length);
  const e = EXPERTS[idx];

  return (
    <section id="team" className="bg-secondary/30 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Unsere Experten-Profile
          </h2>
          <p className="mt-3 text-muted-foreground">
            Interdisziplinäre Expertise für Ihre Kapitalrückführung. Lernen Sie die Köpfe hinter Veritas kennen.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl bg-card shadow-[var(--shadow-elegant)] h-auto  sm:h-[660px]">
          <div className="grid md:grid-cols-2 items-stretch">
            <div id="expert-image-anchor" className="relative aspect-[4/5] md:aspect-auto h-auto sm:h-[660px]">
              <img
                key={e.image}
                src={e.image}
                alt={`${e.name} — ${e.role}`}
                width={1024}
                height={1024}
                loading="eager"
                decoding="async"
                fetchPriority="high"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
            <div className="flex flex-col justify-center bg-navy p-8 text-primary-foreground md:p-12">
              <p className="text-xs font-semibold uppercase tracking-widest text-gold">
                {e.badge}
              </p>
              <h3 className="mt-3 text-2xl font-bold md:text-3xl">{e.name}</h3>
              <p className="text-gold">{e.role}</p>
              <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/80 md:text-base">
                {e.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
                <div className="flex items-center gap-2 pt-2 text-sm text-white/85">
                  <Mail className="h-4 w-4 text-gold" />
                  <a href={`mailto:${e.email}`} className="transition-colors hover:text-gold">
                    {e.email}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-col items-center gap-4">
          <div className="flex gap-3">
            <button
              onClick={prev}
              aria-label="Vorheriger Experte"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border bg-card text-foreground transition-colors hover:border-gold hover:text-gold"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={next}
              aria-label="Nächster Experte"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border bg-card text-foreground transition-colors hover:border-gold hover:text-gold"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
          <div className="flex gap-2">
            {EXPERTS.map((_, i) => (
              <button
                key={i}
                onClick={() => updateExpert(i)}
                aria-label={`Experte ${i + 1}`}
                className={cn(
                  "h-2 w-2 rounded-full transition-all",
                  i === idx ? "w-6 bg-gold" : "bg-border hover:bg-muted-foreground",
                )}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}